type AgendaEntry = {
    controller: AbortController
    relatives: string[]
}

type Agenda = {
    [key: string]: AgendaEntry
}

const agenda: Agenda = {}

const AbortionClinic = {
    /**
     * Send signal to abort call
     * @param actionType Action type to abort its signal
     * @returns If abortion signal was sent
     */
    abortActionCall(actionType: string): boolean {
        const actionAgenda: AgendaEntry = agenda[actionType]

        if (!actionAgenda) {
            return false
        }

        const controller: AbortController = actionAgenda.controller
        let output = false

        if (!controller.signal.aborted) {
            controller.abort()
            output = true
        }

        delete agenda[actionType]
        output = actionAgenda.relatives.some(AbortionClinic.abortActionCall) || output

        return output
    },

    /**
     * Delete entry for a certain type, and its relatives
     * @param actionType Action type to delete
     */
    deleteAgendaEntry(actionType: string): void {
        const actionAgenda: AgendaEntry = agenda[actionType]

        if (!actionAgenda) {
            return
        }

        delete agenda[actionType]
        actionAgenda.relatives.some(AbortionClinic.deleteAgendaEntry)
    },

    /**
     * Get signal for a given API call action. If another signal
     * was already dispatched, it aborts the previous one
     * @param actionType Action types to watch
     */
    getSignal(actionType: string | string[]): AbortSignal {
        const controller: AbortController = new AbortController()

        if (Array.isArray(actionType)) {
            actionType.forEach(AbortionClinic.abortActionCall)

            actionType.forEach((innerActionType: string) => {
                const actionAgenda: AgendaEntry = {
                    controller,
                    relatives: actionType.filter((t: string) => t !== innerActionType),
                }

                agenda[innerActionType] = actionAgenda
            })
        } else {
            AbortionClinic.abortActionCall(actionType)
            const actionAgenda: AgendaEntry = {
                controller,
                relatives: [],
            }

            agenda[actionType] = actionAgenda
        }

        return controller.signal
    },
}

export default AbortionClinic
